import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessHours.css";
import flashMessage from '../HelperFunctions';


function BusinessHours({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Mon-Fri: 9am-5pm Sat-Sun: Closed`;

  const typingTimer = useRef(null);
  const hoursInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div className="customize-ai-section">
      <span>Business Hours</span>
      <input
        data-say-id="knowledge-base-hours"
        ref={hoursInputRef}
        className="business-hours-text"
        placeholder={placeholderText}
        defaultValue={organization.business_hours}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default BusinessHours
